module.exports = __webpack_public_path__ + "static/media/2-img.378c9e9b.png";